var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"propertiesContainer",staticClass:"properties-container",class:{ digital: _vm.isDigital }},[_c(_vm.renderObject,{tag:"component",attrs:{"is-digital":_vm.isDigital}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }